export default __webpack_public_path__ + "static/media/email.6d9e62c2.svg";